'use strict';

module.exports = function reverse() {
  var collection = [].concat(this.items).reverse();
  return new this.constructor(collection);
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/reverse.js
// module id = 1706
// module chunks = 2